import React from "react";
import "antd/dist/antd.css";
import Apps from "./containers/app";
import AuthProvider from "./contexts/auth/provider";
import LeadProvider from "./contexts/leads/provider";

function App() {
  return (
    <AuthProvider>
      <LeadProvider>
        <Apps />
      </LeadProvider>
    </AuthProvider>
  );
}

export default App;
